const customStyleMap = {
  CODE: {
    borderRadius: "4px",
    padding: "1px 4px",
    fontFamily: "monospace"
  }
};

export default customStyleMap;
